<template>
  <div class="meeting-agenda">
    <div class="page-header-banner">
      <div class="banner-main-content">
        <h1>大会议程</h1>
        <p>CONFERENCE AGENDA</p>
        <p>2021/12/01 - 2021/12/03</p>
      </div>
    </div>
    <div class="agenda-list">
      <div class="common-forum-agenda main-forum-agenda">
        <div class="main-title">
          <div>主论坛</div>
          <div></div>
          <div>
            {{ mainActivityTime }}
          </div>
        </div>
        <div class="main-timetable">
          <div
            v-for="(item, index) in mainTimeList"
            :key="index"
            style="display:flex;margin-bottom: 10px;"
          >
            <p class="border-left" style="width:6px"></p>
            <div class="timetable-one" style="width:1200px">
              <div>
                <div class="activity-time">{{ item.time }}</div>
                <div class="activity-name">{{ item.active }}</div>
              </div>
              <div>
                <div class="speaker-name">{{ item.speaker }}</div>
                <div class="speaker-position">{{ item.company }}</div>
                <div class="speaker-position">{{ item.position }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fen-back">
      <div
        class="common-forum-agenda sub-forum-agenda"
        style="width:1200px;margin:0 auto;padding-bottom: 80px"
      >
        <div class="main-title">
          <div>分论坛</div>
          <div></div>
          <div>{{ activityTime }}</div>
        </div>
        <div class="main-timetable">
          <div class="timetable-time-fourm">
            <div class="time-list">
              <span
                v-for="(item, index) of subDateList"
                :key="index"
                :class="{ 'activity-time': currentDate === item }"
                @click="changeDate(item)"
                >{{ item }}</span
              >
              <p>
                （分论坛逐日解锁，请选择日期查看）
              </p>
            </div>
            <div class="forum-list">
              <span
                :class="{ 'tab-active': classifyId == item.id }"
                v-for="item in showTableList"
                :key="item.id"
                @click="getClassifyClick(item.id)"
                >{{ item.subFourm }}</span
              >
            </div>
          </div>

          <div class="timetable-list">
            <div
              v-for="(subItem, ind) in subList"
              :key="ind"
              style="display:flex;margin-bottom: 10px;"
            >
              <p class="border-left" style="width:6px"></p>
              <div class="timetable-one" style="width:1200px">
                <div>
                  <div class="activity-time">{{ subItem.time }}</div>
                  <div class="activity-name">{{ subItem.active }}</div>
                </div>
                <div>
                  <div class="speaker-name">{{ subItem.speaker }}</div>
                  <div class="speaker-position">{{ subItem.position }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      timetableList: [
        "前端体验",
        "高性能",
        "低码",
        "人工智能",
        "区块链",
        "高性能",
        "数据技术",
        "云原生"
      ],
      classifyId: 0,
      mainTimeList: [], //主论坛时间表
      subTimeList: [], //分论坛数据
      subList: [], //在展示的分论坛
      activityTime: "", // 当前分论坛的时间
      showTableList: [],
      mainActivityTime: "",
      subDateList: [], //分论坛直播的日期
      currentDate: "" // 当前选择的分论坛日期
    };
  },

  components: {},

  computed: {},
  watch: {
    // 主论坛的时间根据时间表来截取第一个议程开始时间和最后一个议程结束时间
    mainTimeList: {
      deep: true,
      handler: function(nval, oval) {
        const indexOf = nval[0].time.indexOf("-");
        const indexOf2 = nval[nval.length - 1].time.indexOf("-");
        this.mainActivityTime =
          nval[0].time.substring(0, indexOf) +
          "-" +
          nval[nval.length - 1].time.substring(0, indexOf2);
      }
    }
  },
  mounted() {
    this.getMainTimeList();
    this.getSubTimeList();
  },

  methods: {
    /**
     * 描述
     * 为了实现进入页面可以根据当前时间进入分论坛，增加一个时间获取函数，在加载数据跳到当前时间直播的分论坛
     * @date 2021-11-08
     * @returns {any}
     */
    getLocalTime() {
      const timeStamp = new Date();
      const currentDay = timeStamp.getDate();
      if (timeStamp.getMonth() === 11) {
        if (currentDay === 1) {
          this.changeDate("12月01日");
        } else if (currentDay === 2) {
          this.changeDate("12月02日");
        } else if (currentDay === 3) {
          this.changeDate("12月03日");
        }
      } else {
        this.changeDate("12月01日");
      }
    },

    //从cms上获取主论坛时间
    getMainTimeList() {
      axios({
        url:
          "/r/cms/www/itn/json/deveConference/mainTimeList.json?time=" +
          +new Date(),
        method: "get",
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        withCredentials: true
      }).then(res => {
        // 数据筛选将没有speaker字段的“全部回放”项目去除
        this.mainTimeList = res.data.filter(item => item.speaker != null);
      });
    },
    //从cms上获取分论坛时间
    getSubTimeList() {
      axios({
        url:
          "/r/cms/www/itn/json/deveConference/testFroumList.json?time=" +
          +new Date(),
        method: "get",
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        withCredentials: true
      }).then(res => {
        this.subTimeList = res.data;
        this.subList = this.subTimeList[0].list;
        // 配置分论坛时间表
        this.activityTime = this.subTimeList[0].time;
        res.data.map(val => {
          if (!this.subDateList.includes(val.date)) {
            this.subDateList.push(val.date);
          }
        });
        this.getLocalTime();
      });
    },
    getClassifyClick(id) {
      let this_ = this;
      this_.classifyId = id;
      this_.subTimeList.forEach(ele => {
        if (id == ele.id) {
          this_.subList = [];
          // 为了去除观看全部的第一行，因为和播放页用了同一个数据源，做一下数据筛选,条件是演讲者speaker为不为null
          this_.subList = ele.list.filter(item => item.speaker != null);
          // 配置论坛时间表
          this_.activityTime = ele.time;
        }
      });
    },
    // 查看另一日期的分论坛议程
    changeDate(date) {
      this.currentDate = date;
      const res = [];
      for (let item of this.subTimeList) {
        if (date === item.date) {
          res.push({ subFourm: item.area_name, id: item.id });
        }
      }
      this.showTableList = [...res];
      this.getClassifyClick(res[0].id);
    }
  }
};
</script>
<style lang="scss" scoped>
.fen-back {
  background: url("../../../assets/developerConference/fen-back.png") no-repeat
    center;
  background-size: cover;
  width: 100%;
}
.border-left {
  background: url("../../../assets/developerConference/border-left.png")
    no-repeat center;
  background-size: cover;
}
.common-forum-agenda {
  .main-title {
    display: flex;
    align-items: center;
    font-size: 30px;
    font-family: PingFangSC-Semibold;
    padding-top: 64px;
    padding-bottom: 43px;
    > div:nth-child(1) {
      color: #000000;
      font-family: PingFangSC-Semibold;
      // font-weight: 700;
    }
    > div:nth-child(2) {
      width: 3px;
      height: 21px;
      padding: 0 18px;
      background: url("../../../assets/developerConference/division_line.png")
        no-repeat center;
      background-size: contain;
    }
    > div:nth-child(3) {
      color: #333333;
    }
  }
  .main-timetable {
    .timetable-one {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #ffffff;
      border: 1px solid #d2dbe8;
      border-radius: 3px;
      min-height: 80px;
      font-size: 16px;
      color: #666666;
      // border-left: 3px solid #1f70fd;
      > div:nth-child(1) {
        .activity-time {
          float: left;
          padding-left: 54px;
          width: 210px;
        }
        .activity-name {
          font-family: MicrosoftYaHei-Bold;
          font-weight: 700;
          color: #333333;
          float: left;
        }
      }
      > div:nth-child(2) {
        padding: 18px 0px;
        width: 300px;
        .speaker-name {
          color: #1f70fd;
        }
      }
      // &:nth-child(2n) {
      //   // border-left: 3px solid #16d1d0;
      // }
    }
  }
}
.meeting-agenda {
  background-color: #fff;
  .page-header-banner {
    width: 100%;
    min-width: 1200px;
    height: 465px;
    background: url("../../../assets/developerConference/agenda_banner-big.jpg")
      no-repeat center center;
    background-size: cover;
    // background-size: 3500px 465px;
    color: #ffffff;
    color: #000000;

    .banner-main-content {
      width: 1200px;
      margin: 0 auto;
      // padding-left: 78.8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      h1 {
        font-family: MicrosoftYaHei-Bold;
        font-size: 44px;
        padding-top: 159px;
        color: #333333;
        line-height: 54px;
        font-weight: 700;
      }
      p {
        font-family: MicrosoftYaHei-Bold;
        font-size: 28px;
        color: #ffffff;
        color: #000000;
        text-align: left;
        &:last-of-type {
          font-family: MicrosoftYaHei;
          font-size: 22px;
          opacity: 0.8;
          padding-top: 5px;
        }
      }
    }
  }
  @media (max-width: 1366px) {
    .page-header-banner {
      height: 399px;
      background: url("../../../assets/developerConference/agenda_banner-small.jpg")
        no-repeat center center;
    }
  }
  .agenda-list {
    margin: 0 auto;
    // padding-top: 77px;
    width: 1200px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #333333;
    overflow: hidden;
    .common-forum-agenda {
      .main-title {
        display: flex;
        align-items: center;
        font-size: 30px;
        font-family: PingFangSC-Semibold;
        padding-bottom: 43px;
        > div:nth-child(1) {
          color: #000000;
          font-family: PingFangSC-Semibold;
          // font-weight: 700;
        }
        > div:nth-child(2) {
          width: 3px;
          height: 21px;
          padding: 0 18px;
          background: url("../../../assets/developerConference/division_line.png")
            no-repeat center;
          background-size: contain;
        }
        > div:nth-child(3) {
          color: #333333;
        }
      }
      .main-timetable {
        .timetable-one {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #ffffff;
          border: 1px solid #d2dbe8;
          border-radius: 3px;
          min-height: 80px;
          // margin-bottom: 10px;
          font-size: 16px;
          color: #666666;
          // border-left: 3px solid #1f70fd;
          > div:nth-child(1) {
            .activity-time {
              float: left;
              padding-left: 54px;
              width: 210px;
            }
            .activity-name {
              font-family: MicrosoftYaHei-Bold;
              font-weight: 700;
              color: #333333;
              float: left;
            }
          }
          > div:nth-child(2) {
            padding: 18px 0px;
            width: 300px;
            .speaker-name {
              color: #1f70fd;
            }
          }
          // &:nth-child(2n) {
          //   // border-left: 3px solid #16d1d0;
          // }
        }
      }
    }
    .main-forum-agenda {
      margin-bottom: 64px;
    }

    .sub-forum-agenda {
      margin-bottom: 128px;
    }
  }
}
.speaker-position {
  width: 246px;
  font-size: 14px;
}
</style>
<style lang="scss">
.timetable-time-fourm {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  .time-list {
    display: flex;
    justify-content: space-between;
    & span {
      display: inline-block;
      font-size: 16px;
      height: 24px;
      cursor: pointer;
    }
    span {
      position: relative;
      // background-image: linear-gradient(270deg, #4945ff 0%, #3ffffe 100%);
      // 下划线
      &::after {
        content: "";
        position: absolute;
        width: 100%;
        transform: scaleX(0);
        height: 2px;
        bottom: -10px;
        left: 0;
        background-image: linear-gradient(270deg, #4945ff 0%, #3ffffe 100%);
        transform-origin: bottom right;
        transition: transform 0.25s ease-out;
      }
      &:hover::after {
        transform: scaleX(1);
        transform-origin: bottom left;
      }
    }
    span:nth-child(2) {
      margin: 0 20px;
    }
    .activity-time {
      color: #0d3dfa;
      position: relative;
      &::after {
        display: inline-block;
        content: "";
        height: 2px;
        transform: scaleX(1);
        transform-origin: bottom left;
        width: 100%;
        background-image: linear-gradient(270deg, #4945ff 0%, #3ffffe 100%);
        position: absolute;
        bottom: -10px;
        left: 0;
      }
    }
    & p {
      margin-left: 12px;
      height: 24px;
      font-size: 16px;
    }
  }
  .forum-list {
    position: relative;
    left: 12px;
    display: flex;
    & span {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 137px;
      margin: 0 16px;
      height: 40px;
      background: #e2e5f4;
      border-radius: 2px;
      cursor: pointer;
    }
    .tab-active {
      background: url("../../../assets/developerConference/tab_bg.png")
        no-repeat center;
      background-size: 100% 100%;
      font-family: PingFangSC-Semibold;
      color: #ffffff;
      font-weight: 600;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/meetingAgenda.vue